'use client';

import type { CSSProperties } from 'react';
import { MACARON } from './tokens';

export const MACARON_CARD_SURFACE_CLASSNAME = 'w-full md:w-fit md:min-w-[360px] md:max-w-full overflow-hidden rounded-2xl px-5 py-4';

export function getMacaronCardSurfaceStyle(): CSSProperties {
  return {
    // The translucent fill + soft shadow already separate these cards from the chat background.
    // Keeping a border on top of that made structured canvas cards look double-framed in practice.
    // Keep the Tailwind-equivalent layout values here as style fallbacks, not global CSS:
    // Uno has repeatedly missed `px-5` and `md:w-fit` during route-level extraction, which makes
    // cards look flush-left or full-width. The className above stays close to macaron-web;
    // these explicit values preserve the same visual contract when Uno extraction drifts.
    width: 'fit-content',
    minWidth: 360,
    maxWidth: '100%',
    padding: '1rem 1.25rem',
    backgroundColor: MACARON.cardBg,
    boxShadow: MACARON.cardShadow,
    backdropFilter: 'blur(12px)',
  };
}
